import React from "react";
import { Outlet, useNavigate } from "react-router-dom";

import { getApiEnv, getApiEnvLabel, isApiEnvSwitchEnabled } from "../../api/apiEnv";
import { useAppDispatch } from "../../store/hooks";
import { logout } from "../../store/slices/authSlice";
import SideNav from "./SideNav";

const AdminLayout = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const apiEnv = getApiEnv();

  const onLogout = () => {
    dispatch(logout());
    navigate("/admin/login");
  };

  return (
    <div className="admin-root">
      <header className="admin-topbar">
        <div className="brand-logo">
          NANUM ERP Admin
          {isApiEnvSwitchEnabled() && (
            <span className={`api-env-badge api-env-badge--${apiEnv}`}>{getApiEnvLabel(apiEnv)}</span>
          )}
        </div>
        <button className="logout-btn" type="button" onClick={onLogout}>
          로그아웃
        </button>
      </header>
      <div className="admin-content-wrap">
        <SideNav />
        <main className="admin-content-panel">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
